import moment from 'moment';
import { AvailabilitySlot, Discount, Price } from 'shared-types/Common';

type SelectedArrivalTime = {
  startTime?: string;
  startDateTime?: string;
};

type SlotPricing = {
  price?: Price;
  discount?: Discount;
};

export const findSlotForArrivalTime = (
  slots: unknown,
  arrivalTime?: SelectedArrivalTime
): AvailabilitySlot | undefined => {
  if (!arrivalTime || !Array.isArray(slots)) return undefined;

  return (slots as AvailabilitySlot[]).find((slot) =>
    arrivalTime.startDateTime
      ? moment(slot.startDateTime).isSame(moment(arrivalTime.startDateTime), 'minute')
      : moment(slot.startDateTime).format('HH:mm') === arrivalTime.startTime
  );
};

// The API lowers the entity price to the cheapest slot of the day, so it is a "from" price.
export const resolveSlotPricing = (
  entity: SlotPricing | undefined,
  slot: SlotPricing | undefined
): SlotPricing =>
  slot?.price
    ? { price: slot.price, discount: slot.discount }
    : { price: entity?.price, discount: entity?.discount };
